import React from "react";
import { Col, ProgressBar, Row, OverlayTrigger, Tooltip } from "react-bootstrap";

import { BigPicture, Common } from "../../../helper";

import "../../../assets/stlyes/BigPicture/Progress.scss";

const StackedColumnChart = (props) => {
  const { subject } = props;
  // const [addedOnce, setAddedOnce] = useState(false);

  const Styles = {
    progressBarMain_: {
      borderRadius: "0px 10px 10px 0px",
      marginLeft: "-11px"
    },
    tooltipText: {
      display: "flex",
      alignItems: "center"
    },
    progressBarPopUp:{
      fontWeight:"600",
      fontSize:"12px"
    }
  }

  const setBackgroundColor = (key) => {
    return (key === BigPicture.ProgressInputKeys.Ontrack ? "var(--ontrack-color)" : key === BigPicture.ProgressInputKeys.NotOnTrack ? "var(--not-ontrack-color)" : key === BigPicture.ProgressInputKeys.Exceeding ? "var(--exceeding-color)" : "var(--unknown-color)")
  };

  const renderTooltip = (item) => (
    <Tooltip>
      <div style={Styles.tooltipText}><div className="greenPointer_" style={{ backgroundColor: "var(--exceeding-color)" }} />&nbsp;{`${Common.Exceeding}: ${item.value.exceeding.percent} (${item.value.exceeding.number})`}</div>
      <div style={Styles.tooltipText}><div className="greenPointer_" style={{ backgroundColor: "var(--ontrack-color)" }} />&nbsp;{`${Common.OnTrack_}: ${item.value.onTrack.percent} (${item.value.onTrack.number})`}</div>
      <div style={Styles.tooltipText}><div className="greenPointer_" style={{ backgroundColor: "var(--not-ontrack-color)" }} />&nbsp;{`${Common.NotOnTrack}: ${item.value.notOnTrack.percent} (${item.value.notOnTrack.number})`}</div>
      <div style={Styles.tooltipText}><div className="greenPointer_" style={{ backgroundColor: "var(--unknown-color)" }} />&nbsp;{`${Common.Unkown}: ${item.value.unknown.percent} (${item.value.unknown.number})`}</div>
    </Tooltip>
  );

  // Since first object is hiding in UI here im adding first element only one time
  // useEffect(() => {
  //   if (!addedOnce) {
  //     Object.values(subject)[0].unshift(Object.values(subject)[0][0]);
  //     setAddedOnce(true);
  //   }
  // }, [subject, addedOnce]);

  return (
    <div className="stackedColumnChartMain">
      <div className="stackedColumnChartSub">
        {Object.values(subject).filter(Array.isArray)[0].map((item, i) => (
          <Col key={i} xs={12} className="columnParent" >
            <Row>
              <Col xs={12} sm={3} className="axisLabel">
                <OverlayTrigger placement="bottom" overlay={<Tooltip> <span style={Styles.progressBarPopUp}>{item?.name}</span></Tooltip>}>
                  <small className="ProgressBar-title">{`${item.name}`}</small>
                </OverlayTrigger>
              </Col>
              <Col xs={12} sm={9} className="graphLanding">
                {/* {i !== 0 && <div className="labels">
                  <small>{item.value.exceeding.percent}</small>
                  <small>{item.value.onTrack.percent}</small>
                  <small>{item.value.notOnTrack.percent} </small>
                  <small>{item.value.unknown.percent}</small>
                </div>} &nbsp; */}
                <OverlayTrigger placement="top" overlay={renderTooltip(item)}>
                  <ProgressBar className="progressBarMain_" now={100} style={Styles.progressBarMain_}>
                    {Object.entries(item.value).map(([key, value], j) => (
                      <ProgressBar key={j} now={parseFloat(value.percent.replace("%", ""))} style={{ backgroundColor: setBackgroundColor(key) }} />
                    ))}
                  </ProgressBar>
                </OverlayTrigger>
              </Col>
            </Row>
          </Col>
        ))}
      </div>
    </div>
  )
}

export { StackedColumnChart }